<template>
  <div
    id="grocery"
    class="page-content"
  >
    <PageFormsList />
    <div class="row">
      <div class="col-sm-6 col-12">
        <ebt-card-information />
        <create-grocery />
        <send-grocery-history />
        <create-grocery-shopper-note />
        <remove-grocery-shopper-note />
        <cancel-grocery />
        <grocery-status />
      </div>
      <div class="col-sm-6 col-12">
        <grocery-estimation-and-cost />
        <send-and-pull-receipt />
        <create-pending-grocery-cart />
        <create-saved-grocery-from-instacart-cart />
        <scan-grocery />
        <grocery-charge />
      </div>
      <div class="col-12">
        <grocery-available-stores />
        <instacart-accounts-table />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent, watch } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useGrocery } from '@/use/grocery';

const GroceryEstimationAndCost = defineAsyncComponent(() => import('./Grocery/GroceryEstimationAndCost.vue') as any);
const CreateGrocery = defineAsyncComponent(() => import('./Grocery/CreateGrocery.vue') as any);
const EbtCardInformation = defineAsyncComponent(() => import('./Grocery/EbtCardInformation.vue') as any);
const CancelGrocery = defineAsyncComponent(() => import('./Grocery/CancelGrocery.vue') as any);
const ScanGrocery = defineAsyncComponent(() => import('./Grocery/ScanGrocery.vue') as any);
const GroceryAvailableStores = defineAsyncComponent(() => import('./Grocery/GroceryAvailableStores.vue') as any);
const SendAndPullReceipt = defineAsyncComponent(() => import('./Grocery/SendAndPullReceipt.vue') as any);
const InstacartAccountsTable = defineAsyncComponent(() => import('./Grocery/InstacartAccountsTable.vue') as any);
const SendGroceryHistory = defineAsyncComponent(() => import('./Grocery/SendGroceryHistory.vue') as any);
const CreatePendingGroceryCart = defineAsyncComponent(() => import('./Grocery/CreatePendingGroceryCart.vue') as any);
const CreateSavedGroceryFromInstacartCart = defineAsyncComponent(() => import('./Grocery/CreateSavedGroceryFromInstacartCart.vue') as any);
const CreateGroceryShopperNote = defineAsyncComponent(() => import('./Grocery/CreateGroceryShopperNote.vue') as any);
const GroceryCharge = defineAsyncComponent(() => import('./Grocery/GroceryCharge.vue') as any);
const GroceryStatus = defineAsyncComponent(() => import('./Grocery/GroceryStatus.vue') as any);

const RemoveGroceryShopperNote = defineAsyncComponent(() => import('./Grocery/RemoveGroceryShopperNote.vue') as any);

const { isNeedToShowFirstGroceryPopup } = useCustomer();
const { showFirstGroceryPopup } = useGrocery();

watch(isNeedToShowFirstGroceryPopup, showFirstGroceryPopup, {
  immediate: true,
});

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
